require('./bootstrap');

import Vue from 'vue';
import VueMeta from 'vue-meta'
import moment from 'moment'
import VueGtag from "vue-gtag"

import { createInertiaApp, Link } from '@inertiajs/inertia-vue';
import PortalVue from 'portal-vue';
import navigateForVuetify from './Mixins/navigateForVuetify'
import breakpoint from './Mixins/breakpoint';
import vuetify from './Plugins/vuetify'
import store from './Plugins/Store/index'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'

// Import Bootstrap and BootstrapVue CSS files (order is important)
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import { InertiaProgress } from '@inertiajs/progress'
import { Inertia } from '@inertiajs/inertia'

Vue.mixin({ methods: { route } });
// Vue.use(InertiaApp);
// Vue.use(InertiaForm);
Vue.prototype.moment = moment
Vue.use(PortalVue);

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)

function initMixins() {
  Vue.mixin(navigateForVuetify)
  Vue.mixin(breakpoint)
}

function initAnalytics() {
  var analyticskey = document.querySelector('meta[name=ganalytics-key]').getAttribute('content')
  Vue.use(VueGtag, {
    config: {
      id: analyticskey,
      params: {
        send_page_view: true
      }
    }
  })
}

// vue-meta
function initMeta() {
  Vue.use(VueMeta, {
    keyName: 'metaInfo',
    attribute: 'data-vue-meta',
    ssrAttribute: 'data-vue-meta-server-rendered',
    tagIDKeyName: 'vmid',
    refreshOnceOnNavigation: true
  })
}

// initiate inertia listener
function initInertia() {

  InertiaProgress.init()

  Inertia.on('success', (e) => {
  // })
  // document.addEventListener('inertia:success', (e) => {
    setTimeout(() => {
      // console.log('inertia event', e.target.title, e.target.URL)
      var path = {
        page_title: e.target.title,
        page_location: e.target.URL,
        page_path: e.target.location.pathname
      }
      // console.log('path', path)
      if (process.env.NODE_ENV == 'production') {
        Vue.$gtag.pageview(path)
      }
    }, 1000);
  })
  Inertia.on('error', (e) => {
    console.error(e, 'inertia on error');
  })
}

// components
Vue.component('inertia-link', Link)
Vue.component('invoices-button',
  require('@/Components/Invoices/button').default
)

import Layout from '@/Layouts/Guest'

createInertiaApp({
  resolve: name => {
    let module = require(`./Pages/${name}`).default

    if (!module.layout) {
      module.layout = Layout
    }
    return module
  },
  // resolve: name => async () => await import( /* webpackMode: 'lazy' */ /* webpackChunkName: "/chunks/[request]" */ `./Pages/${name}`).default,
  setup({ el, App, props, plugin }) {
    Vue.use(plugin)

    let app = new Vue({
      vuetify,
      store,
      mounted() {
        this.$nextTick(() => {
          // console.warn('i am mounted', this);
          initInertia()
          // getMode()
          initAnalytics()
        })
      },
      beforeMount() {
        initMeta()
        initMixins()
      },
      render: h =>h(App, props),
    }).$mount(el)

    if (process.env.NODE_ENV != 'production') {
      window.app = app
    }
  },
})
